module.exports = __webpack_public_path__ + "media/images/pages/fcr/component-1-c0a02b0553e4a357ff5d60267ef3e24f.jpg";